module.exports = __webpack_public_path__ + "static/media/anniversary-post-banner.fa33fc69.svg";